// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <template v-if="isLoading"></template>
    <v-row wrap v-else>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'things'"
        :editRoute="editRoute"
        :filter="localFilters"
        :headers="headers"
        id="_id"
        name="Item"
        permissions="items"
        fuzzySearch
        :searchBarText="searchBarText"
        pagination
        >
          <template slot="footer.prepend">
            <v-btn :href="exportLink" download style="color:black;">Download XLSX</v-btn>
          </template>
        </item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'

import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'
import {LookupMixin, SettingsMixin} from '@/shared/mixins'

export default {
  components: {
    ItemList
  },

  mixins: [LookupMixin, SettingsMixin],

  props: {
    searchBarText: String
  },

  data () {
    return {
      isLoading: true,
      endpoint: ENDPOINT,
      headers: []
    }
  },

  created () {
    if (Object.keys(this.siteSettings).length > 0) this.createHeader()
  },

  computed: {
    ...mapGetters([
      'filters',
      'getCategories',
      'siteSettings'
    ]),

    editRoute: function () {
      var c = this.itemClass
      if (c === '') {
        c = 'thing'
      }
      return c + 'Edit'
    },

    exportLink: function () {
      // Commenting out for issues with large data sets
      var params = {}
        // sort: '-state.lastZoneTime'
      // }

      if (this.itemClass !== '') {
        params.class = this.itemClass
      }

      var url = ENDPOINT + 'things/export?' + new URLSearchParams(params).toString()
      return url
    },

    itemClass: function () {
      var itemClass = ''
      if (this.$route.path.includes('items')) {
        itemClass = 'item'
      } else if (this.$route.path.includes('workers')) {
        itemClass = 'worker'
      }
      return itemClass
    },

    localFilters: function () {
      var f = [] // Object.assign([], this.filters) don't want to filter by site for now
      if (this.itemClass !== '') {
        f.push({'name': 'class', 'value': this.itemClass})
      }
      f.push({'name': 'sort', 'value': '-state.lastZoneTime'})
      return f
    }
  },

  methods: {
    ...mapActions([
      'fetchCategories'
    ]),

    formatName: function (item) {
      var name = item.common.name
      if (item.state.alarmTamper) {
        name = name + ' - ' + '(Alarm)'
      }
      return name
    },

    createHeader: function () {
      this.headers = [
        {
          text: this.getItemNameLabel(this.siteSettings.itemNameLabel),
          value: 'common.name',
          function: this.formatName,
          sortable: true
        },
        {
          text: 'Categories',
          value: 'common.categories',
          sortable: true,
          function: this.getCategoryName
        },
        {
          text: this.getItemSerialLabel(this.siteSettings.itemSerialLabel),
          value: 'common.serial',
          sortable: true
        }
      ]
      if (this.siteSettings.thingHeaders != null && this.siteSettings.thingHeaders.includes('label')) {
        this.headers.push({
          text: 'Labels',
          value: 'common.labels',
          function: this.formatThingLabels,
          sortable: true
        })
      } else {
        this.headers.push({
          text: 'Tags',
          value: 'common.tags',
          function: this.getThingTags,
          sortable: true
        })
      }

      this.headers.push({
        text: 'Zone Entry Time',
        value: 'state.lastZoneTime',
        function: this.formatTime,
        sortable: true
      })
      this.headers.push({
        text: 'Zone',
        value: 'zone',
        context: ENDPOINT + 'zones?limit=3000',
        function: this.getZoneName,
        sortable: false
      })
      this.isLoading = false
    },

    formatTime: function (item) {
      var zoneTime = moment(String(item.state.lastZoneTime))
      if (zoneTime.isAfter('1000-01-01')) {
        return zoneTime.format('MM/DD/YYYY hh:mm a')
      }

      var endpointTime = moment(String(item.state.lastEndpointTime))
      if (endpointTime.isAfter('1000-01-01')) {
        return endpointTime.format('MM/DD/YYYY hh:mm a')
      }

      var eventTime = moment(String(item.state.lastEvent))
      if (eventTime.isAfter('1000-01-01')) {
        return eventTime.format('MM/DD/YYYY hh:mm a')
      }

      return 'N/A'
    },

    formatThingLabels: function (item) {
      if (item.common.labels === null || item.common.labels === undefined) {
        return ''
      }
      return item.common.labels.toString().replaceAll(',', ', ')
    },

    getCategoryName: function (item) {
      var arr = []
      var splitCategories = []
      if (item.common.categories.includes(',')) {
        splitCategories = item.common.categories.split(', ')
      }

      for (var x in item.common.categories) {
        for (let y of this.getCategories) {
          if (splitCategories.includes(y.name) || item.common.categories === y.name) { // We already fetched the category names
            return item.common.categories
          }
          if (y.id === item.common.categories[x]) {
            arr.push(y.name)
          }
        }
      }
      arr.length !== 0 ? item.common.categories = arr.toString().replaceAll(',', ', ') : item.common.categories = ''
      return item.common.categories
    },

    getZoneName: function (item, list) {
      if (item.state.endpoint) {
        if (item.state.endpoint !== '' && list) {
          var zone = list.find((el) => el._id === item.state.zone)
          if (zone) {
            return zone.name
          }
        }
      }
      return 'N/A'
    }
  },

  watch: {
    siteSettings: function () {
      this.createHeader()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Things.vue